<template>
  <payment-link-layout :hideSecurityWarningOnMobile="true">
    <template v-slot:content>
      <asset-v3
        class="phone-icon"
        dir="icons"
        name="phone-unavailable.svg"
      />
      <h2 class="gray-900 title-regular">Link de pagamento expirado</h2>
      <p class="gray-900 body-regular">
        Este link de pagamento não existe ou não é mais válido.
      </p>
    </template>
  </payment-link-layout>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';
import PaymentLinkLayout from '../layout/PaymentLinkLayout.vue';

export default {
  name: 'PaymentLinkExpired',
  components: {
    AssetV3,
    PaymentLinkLayout,
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .title-regular {
    font-size: 28px;
    line-height: 36px;
    margin: 12px 0 20px 0;
  }

  .phone-icon {
    margin-top: 28px;

    @media(min-width: $breakpoint-large) {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media(min-width: $breakpoint-large) {
    h2, p {
      text-align: center;
    }
  }
</style>
